import clsx from 'clsx';
import styles from './Skeleton.module.css';

export interface SkeletonProps {
  readonly width?: string | number;
  readonly height?: string | number;
  readonly radius?: string;
  readonly className?: string;
}

/** A single shimmering block. Compose these to mirror the real layout. */
export function Skeleton({ width = '100%', height = 16, radius, className }: SkeletonProps) {
  return (
    <span
      className={clsx(styles.skeleton, className)}
      style={{ width, height, ...(radius === undefined ? {} : { borderRadius: radius }) }}
    />
  );
}

/**
 * Loading placeholder for a table, matching the real column count so the layout
 * does not jump when data arrives.
 */
export function TableSkeleton({ rows = 6, columns = 5 }: { rows?: number; columns?: number }) {
  return (
    <div className={styles.table} role="status" aria-label="Loading results">
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div key={rowIndex} className={styles.row}>
          {Array.from({ length: columns }, (_, columnIndex) => (
            <Skeleton key={columnIndex} height={14} />
          ))}
        </div>
      ))}
    </div>
  );
}
